import axios from '../axios';
const END_POINT = '/permission-rooms';


const addPermissionRooms = (payload) => axios.post(`${END_POINT}`, payload);
const getPermissionRooms = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getPermissionRoom = (permissionRoomsId) => axios.get(`${END_POINT}/${permissionRoomsId}`);
const updatePermissionRooms = (id, payload) => axios.patch(`${END_POINT}/${id}`, payload);
const searchPermissionRooms = (payload) => axios.post(`${END_POINT}/search`, payload);
const deletePermissionRooms = (permissionRoomsId) => axios.delete(`${END_POINT}/${permissionRoomsId}`);

export {
    addPermissionRooms,
    getPermissionRooms,
    getPermissionRoom,
    updatePermissionRooms,
    searchPermissionRooms,
    deletePermissionRooms
}
